import { atom, selector } from 'recoil'
import {
  MAX_UPLOAD_SIZE,
  TYPE_FILE,
  TYPE_URL,
  URL_REGEX
} from 'Pages/MessageCreate/const'
import { UPLOADER_VARIANT_DEFAULT } from 'mailup-web-components'

export const pageState = atom({
  key: 'MessageCreatePageState',
  default: {
    isDirty: false,
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger',
    boxError: false,
    warning: false,
    warningAction: undefined, // setta dirty a false per lasciare la pagina
    success: false,
    pageTitle: '',
    pageType: undefined, // TYPE_FILE = 'file', TYPE_URL = 'url' ...
    subject: '',
    isSubjectDirty: false,
    notes: '',
    url: '', // httpUrl or fileUrl
    isUrlDirty: false,
    file: undefined,
    variant: UPLOADER_VARIANT_DEFAULT,
    extension: '',
    response: undefined
  }
})

export const subjectValidState = selector({
  key: 'MessageCreateSubjectValidState',
  get: ({ get }) => {
    const { subject, isSubjectDirty } = get(pageState)
    return subject.trim().length > 0 && isSubjectDirty
  }
})

export const fileValidState = selector({
  key: 'MessageCreateFileValidState',
  get: ({ get }) => {
    const { file } = get(pageState)
    return file && file.size < MAX_UPLOAD_SIZE
  }
})

export const formValidState = selector({
  key: 'MessageCreatesavedFormValidState',
  get: ({ get }) => {
    const { pageType, subject, url, variant } = get(pageState)
    const isFileValidState = get(fileValidState)
    let isValid = false
    if (pageType === TYPE_URL) {
      isValid =
        subject.trim().length > 0 &&
        url.trim().length > 0 &&
        url.match(URL_REGEX)
    } else if (pageType === TYPE_FILE) {
      isValid =
        subject.trim().length > 0 && isFileValidState && variant === 'uploaded'
    }
    return isValid
  }
})

export const getResponse = selector({
  key: 'MessageCreateGetResponse',
  get: ({ get }) => {
    const { response } = get(pageState)
    return response
  }
})
